import { DocCheck, Chat, Person } from '../Icons';

export default function Pillars() {
  return (
    <section id="how-it-works" className="section container">
      <div className="pillars__head">
        <span className="eyebrow">How reeve helps</span>
        <h2 className="pillars__title">A HR department in your pocket.</h2>
      </div>
      <div className="pillars__grid">
        <article className="pillar">
          <div className="pillar__icon pillar__icon--green">
            <DocCheck />
          </div>
          <h3 className="pillar__title">A live list of what your company needs</h3>
          <p className="pillar__text">
            We give you the exact documents a business like yours needs and assess each one as you
            add it. Check whether you're compliant at any moment, even as the law and best practice
            keep changing.
          </p>
        </article>

        <article className="pillar">
          <div className="pillar__icon pillar__icon--indigo">
            <Chat />
          </div>
          <h3 className="pillar__title">An assistant that understands UK law</h3>
          <p className="pillar__text">
            Ask anything in plain English. Reeve answers from current UK employment law <em>and</em>{' '}
            your own documents, so you get safe advice for <em>your</em> situation, in
            seconds.
          </p>
        </article>

        <article className="pillar">
          <div className="pillar__icon pillar__icon--green">
            <Person />
          </div>
          <h3 className="pillar__title">Real experts, one click away</h3>
          <p className="pillar__text">
            When it's serious, like a grievance, a redundancy or a tricky claim, hand it to a
            CIPD-qualified professional. For when you need a human to look at it.
          </p>
        </article>
      </div>
    </section>
  );
}
